export const comics = [
  {
    id: 1,
    title: '女神降临',
    author: '猫咪',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20cover%20art%20featuring%20a%20stunning%20young%20woman%20with%20makeup%20transformation%2C%20soft%20romance%20atmosphere%2C%20pastel%20pink%20and%20peach%20tones%2C%20Korean%20webtoon%20style%2C%20clean%20simple%20background%20with%20subtle%20sparkles%2C%20elegant%20character%20portrait%2C%20soft%20lighting%2C%20minimal%20composition&width=600&height=840&seq=manhwa-cover-01&orientation=portrait',
    description: '因为外貌被欺负的女生，通过化妆变成女神，却要隐藏真实的自己。一场关于美丽与自信的校园恋爱故事。',
    categories: ['恋爱', '校园'],
    status: '连载中',
    rating: 4.8,
    views: 15200000,
    updateTime: '2026-07-03',
    chapters: 186,
    featured: true,
    trending: true,
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20male%20warrior%20hunter%20with%20dark%20shadow%20powers%2C%20intense%20expression%2C%20dark%20monster%20background%2C%20dramatic%20lighting%2C%20solo%20leveling%20vibe%2C%20epic%20fantasy%20art%20style%2C%20sharp%20contrast%2C%20cool%20color%20tones&width=600&height=840&seq=manhwa-cover-02&orientation=portrait',
    description: '被称为「人类最弱兵器」的成振宇，在经历了生死考验后觉醒了独一无二的升级系统，从此踏上成为最强猎人的道路。',
    categories: ['奇幻', '动作'],
    status: '已完结',
    rating: 4.9,
    views: 28500000,
    updateTime: '2026-06-28',
    chapters: 179,
    featured: true,
    trending: true,
  },
  {
    id: 3,
    title: '再婚皇后',
    author: 'Alpha Tart',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20cover%2C%20beautiful%20queen%20in%20royal%20attire%2C%20palace%20background%2C%20romance%20drama%20vibe%2C%20gold%20and%20crimson%20accents%2C%20historical%20fantasy%20setting%2C%20regal%20atmosphere%2C%20soft%20but%20dramatic%20composition%2C%20Korean%20webtoon%20art%20style&width=600&height=840&seq=manhwa-cover-03&orientation=portrait',
    description: '皇后被皇帝背叛，她毅然选择离婚再婚。在新的婚姻中，她将如何掌握自己的命运？宫廷权谋与浪漫交织。',
    categories: ['恋爱', '剧情'],
    status: '连载中',
    rating: 4.7,
    views: 18900000,
    updateTime: '2026-07-02',
    chapters: 210,
    featured: true,
    trending: true,
  },
  {
    id: 4,
    title: '她的私生活',
    author: '金成妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20attractive%20female%20lead%20in%20modern%20outfit%2C%20art%20gallery%20background%2C%20warm%20rose%20tones%2C%20romantic%20atmosphere%2C%20office%20romance%20vibe%2C%20clean%20composition%2C%20soft%20elegant%20style%2C%20minimal%20background%20elements&width=600&height=840&seq=manhwa-cover-04&orientation=portrait',
    description: '美术馆首席策展人成德美，私底下是偶像站姐。当新馆长发现她的秘密，一场啼笑皆非的恋爱开始了。',
    categories: ['恋爱', '搞笑'],
    status: '已完结',
    rating: 4.6,
    views: 12300000,
    updateTime: '2026-06-15',
    chapters: 120,
    featured: false,
    trending: false,
  },
  {
    id: 5,
    title: '甜蜜家园',
    author: '金坎比',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20horror%20thriller%20manhwa%20cover%2C%20dark%20apartment%20building%2C%20monster%20silhouettes%2C%20survival%20atmosphere%2C%20dark%20moody%20lighting%2C%20tense%20composition%2C%20green%20apartment%20exterior%2C%20creepy%20yet%20artistic%2C%20Korean%20webtoon%20style%2C%20thriller%20genre&width=600&height=840&seq=manhwa-cover-05&orientation=portrait',
    description: '一场突如其来的怪物灾难席卷世界。在封闭的公寓里，幸存者们为了活下去而战斗，人性与恐惧的终极考验。',
    categories: ['悬疑', '恐怖'],
    status: '已完结',
    rating: 4.8,
    views: 20100000,
    updateTime: '2026-06-20',
    chapters: 140,
    featured: false,
    trending: true,
  },
  {
    id: 6,
    title: '全知读者视角',
    author: 'sing N song',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20male%20protagonist%20with%20glowing%20book%2C%20apocalyptic%20fantasy%20world%2C%20constellation%20background%2C%20epic%20storytelling%20vibe%2C%20dramatic%20composition%2C%20blue%20and%20gold%20accents%2C%20mysterious%20atmosphere%2C%20clean%20art%20style&width=600&height=840&seq=manhwa-cover-06&orientation=portrait',
    description: '平凡上班族是唯一读完一部连载十年网络小说的人。当小说世界变成现实，他成了唯一知道结局的人。',
    categories: ['奇幻', '动作'],
    status: '连载中',
    rating: 4.9,
    views: 25000000,
    updateTime: '2026-07-01',
    chapters: 230,
    featured: true,
    trending: true,
  },
  {
    id: 7,
    title: '某天成为公主',
    author: 'Plutus',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20fantasy%20manhwa%20cover%2C%20adorable%20princess%20character%20in%20beautiful%20dress%2C%20royal%20palace%20atmosphere%2C%20soft%20pastel%20colors%2C%20shojo%20manga%20inspired%20style%2C%20flowers%20and%20sparkles%2C%20whimsical%20fairy%20tale%20vibe%2C%20delicate%20art&width=600&height=840&seq=manhwa-cover-07&orientation=portrait',
    description: '穿越成小说中的短命公主，为了不按原著死去，她开始拼命讨好冷酷父皇。温馨治愈的父女宫廷故事。',
    categories: ['恋爱', '奇幻'],
    status: '连载中',
    rating: 4.7,
    views: 17800000,
    updateTime: '2026-07-02',
    chapters: 195,
    featured: false,
    trending: true,
  },
  {
    id: 8,
    title: '金秘书为何那样',
    author: '郑景允',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%2C%20confident%20female%20secretary%20and%20handsome%20boss%2C%20modern%20office%20setting%2C%20warm%20romantic%20tone%2C%20professional%20yet%20playful%20atmosphere%2C%20clean%20composition%2C%20soft%20peach%20and%20cream%20colors%2C%20comedy%20romance%20vibe&width=600&height=840&seq=manhwa-cover-08&orientation=portrait',
    description: '完美秘书突然辞职，自恋副会长才发现自己早已离不开她。一场办公室里的浪漫拉锯战就此展开。',
    categories: ['恋爱', '搞笑'],
    status: '已完结',
    rating: 4.5,
    views: 9800000,
    updateTime: '2026-05-30',
    chapters: 98,
    featured: false,
    trending: false,
  },
  {
    id: 9,
    title: '梨泰院Class',
    author: '赵光真',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20determined%20young%20entrepreneur%20in%20restaurant%20setting%2C%20night%20city%20Itaewon%20background%2C%20neon%20lights%2C%20underdog%20story%20vibe%2C%20warm%20but%20bold%20colors%2C%20modern%20Korean%20setting%2C%20compelling%20composition&width=600&height=840&seq=manhwa-cover-09&orientation=portrait',
    description: '因正义被退学的少年，在梨泰院开了一家小酒馆，誓要向害死父亲的餐饮巨头复仇。热血创业与复仇故事。',
    categories: ['剧情', '热血'],
    status: '已完结',
    rating: 4.8,
    views: 22000000,
    updateTime: '2026-06-10',
    chapters: 112,
    featured: false,
    trending: false,
  },
  {
    id: 10,
    title: '社内相亲',
    author: '海潮',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20manhwa%20cover%2C%20couple%20in%20elegant%20date%20setting%2C%20funny%20misunderstanding%20theme%2C%20bright%20pastel%20colors%2C%20lighthearted%20atmosphere%2C%20modern%20Korean%20style%2C%20clean%20art%2C%20playful%20expressions%2C%20warm%20lighting&width=600&height=840&seq=manhwa-cover-10&orientation=portrait',
    description: '替闺蜜去相亲，对方竟然是公司CEO！为了不被发现，她只能继续伪装身份，恋爱喜剧就此爆发。',
    categories: ['恋爱', '搞笑'],
    status: '已完结',
    rating: 4.6,
    views: 14500000,
    updateTime: '2026-06-25',
    chapters: 135,
    featured: false,
    trending: true,
  },
  {
    id: 11,
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20manhwa%20cover%2C%20mysterious%20tower%20climbing%20theme%2C%20diverse%20character%20silhouettes%2C%20epic%20scale%2C%20dreamlike%20atmosphere%2C%20vertical%20composition%2C%20mysterious%20blue%20light%2C%20Korean%20webtoon%20classic%20style&width=600&height=840&seq=manhwa-cover-11&orientation=portrait',
    description: '少年夜为了追寻唯一的挚友蕾哈尔，闯入神秘之塔。每一层都是一个世界，每一次挑战都是生死考验。',
    categories: ['奇幻', '冒险'],
    status: '连载中',
    rating: 4.7,
    views: 19500000,
    updateTime: '2026-07-01',
    chapters: 580,
    featured: false,
    trending: false,
  },
  {
    id: 12,
    title: '少女的世界',
    author: 'Morang',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%2C%20group%20of%20teenage%20girls%20friendship%2C%20school%20setting%2C%20warm%20pastel%20aesthetic%2C%20slice%20of%20life%20vibe%2C%20soft%20colors%2C%20relatable%20everyday%20moments%2C%20clean%20comic%20style%2C%20gentle%20lighting&width=600&height=840&seq=manhwa-cover-12&orientation=portrait',
    description: '长相平凡的少女和三个超美闺蜜的校园日常。关于友情、成长和自我认同的温暖故事。',
    categories: ['校园', '剧情'],
    status: '连载中',
    rating: 4.4,
    views: 7600000,
    updateTime: '2026-06-30',
    chapters: 160,
    featured: false,
    trending: false,
  },
];

export const featuredComics = comics.filter(c => c.featured);
export const trendingComics = comics.filter(c => c.trending);
export const latestUpdates = [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());